import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AdminPage from './pages/AdminPage';
import PresentationMode from './pages/PresentationMode';
import ControlPanel from './pages/ControlPanel';
import LoginPage from './pages/LoginPage';
import PinEntryPage from './pages/PinEntryPage';
import { RequireAuth } from './components/RequireAuth';
import { RequirePin } from './components/RequirePin';
import './App.css';

function HomePage() {
  const [apiStatus, setApiStatus] = useState<string>('Checking...');

  useEffect(() => {
    fetch('/api/health')
      .then(res => res.json())
      .then(data => setApiStatus(`Connected - ${data.service}`))
      .catch(() => setApiStatus('API not available'));
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Volunteer Committee Presentation System</h1>
        <div className="status-panel">
          <h2>System Status</h2>
          <p>API Status: {apiStatus}</p>
        </div>
        <div className="info-panel">
          <h3>Available Routes:</h3>
          <ul>
            <li><strong>/</strong> - Main application (you are here)</li>
            <li><Link to="/admin" style={{color: '#61dafb'}}>/admin</Link> - Committee admin panel</li>
            <li><Link to="/present" style={{color: '#61dafb'}}>/present</Link> - Presentation mode</li>
            <li><Link to="/control" style={{color: '#61dafb'}}>/control</Link> - Operator control panel</li>
            <li><strong>/api/health</strong> - Health check endpoint</li>
          </ul>
        </div>
        <p className="footer">Volunteer Committee Presentation System - Foundation Setup Complete</p>
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/present-pin" element={<PinEntryPage />} />
        <Route 
          path="/admin" 
          element={
            <RequireAuth requiredRole="Admin">
              <AdminPage />
            </RequireAuth>
          } 
        />
        <Route 
          path="/control" 
          element={
            <RequireAuth>
              <ControlPanel />
            </RequireAuth>
          } 
        />
        <Route 
          path="/present" 
          element={
            <RequirePin>
              <PresentationMode />
            </RequirePin>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
